import { fetchFromRTM, subscribeToRTM } from './index';
import * as constants from './constants';
import './typedef';
import { parseRTMError } from '../../components/AiAssistant/Panel/utils';

const AI_SUMMARY_ACTIONS = {
  CREATE_TASK: 'createTask',
  SUMMARY: 'summary',
  HISTORY: 'history',
  CASE_STUDY: 'case-study',
  TRANSLATE: 'translate',
};

class AISummaryResolver {
  constructor(connection) {
    this.connection = connection;
  }

  generateContent = async ({ ambrosiaUrl, model, max_tokens, contents, taskId, correlationId, action, activityId, accountId, metadata }) => {
    try {
      const message = {
        type: constants.RTM_AUTHOR_SUMMARY_SNS,
        correlationId,
        action,
      };

      if (action === AI_SUMMARY_ACTIONS.CREATE_TASK) {
        message.ambrosiaUrl = ambrosiaUrl;
        message.model = model;
        message.max_tokens = max_tokens;
        message.contents = contents;
        message.elementId = activityId;
        message.accountId = accountId;

      } else if (action === AI_SUMMARY_ACTIONS.SUMMARY) {
        message.taskId = taskId;
        message.accountId = accountId;
      } else if (action === AI_SUMMARY_ACTIONS.HISTORY) {
        message.elementId = activityId;
        message.accountId = accountId;
      } else if (action === AI_SUMMARY_ACTIONS.CASE_STUDY) {
        message.ambrosiaUrl = ambrosiaUrl;
        message.metadata = metadata;
        message.contents = contents;
      } else if (action === AI_SUMMARY_ACTIONS.TRANSLATE) {
        message.contents = contents;
      }

      const response = await fetchFromRTM(
        this.connection,
        message,
        constants.RTM_AUTHOR_SUMMARY_SNS_OK,
        constants.RTM_AUTHOR_SUMMARY_SNS_ERROR,
        constants.UNEXPECTED_ERROR_MESSAGE, // customErrorMessage
        true // returnError - return error objects instead of showing toast internally
      );

      // Check if response contains an error in the data field
      // Error format: {"action":"translate","data":"{\"error\":\"Request failed with status code 504\"}","correlationId":"..."}
      const parsedError = parseRTMError(response);
      if (parsedError) {
        return {
          error: {
            code: parsedError.code || constants.UNKNOWN_ERROR_CODE,
            message: parsedError.message,
          },
        };
      }

      return response;
    } catch (err) {
      // Handle network errors, connection failures, or other exceptions
      const errorMessage = err?.message || err?.toString() || constants.UNEXPECTED_ERROR_MESSAGE;
      return {
        error: {
          code: err?.code || constants.UNKNOWN_ERROR_CODE,
          message: errorMessage,
        },
      };
    }
  };

  summarySubscribe = async (correlationId, listener) => {
    const message = {
      type: constants.RTM_AUTHOR_SUMMARY_SNS_SUBSCRIBE,
      correlationId,
    };

    const subscription = await subscribeToRTM(
      this.connection,
      message,
      listener
    );

    // `await subscribeToRTM(..)` returns null if the subscription cannot be created.
    // In this case return an unsubscribe function that does nothing.
    if (!subscription) {
      const unsubscribeFn = () => { };
      return unsubscribeFn;
    }

    const unsubscribeMessage = {
      type: constants.RTM_AUTHOR_SUMMARY_SNS_UNSUBSCRIBE,
      correlationId,
    };
    const unsubscribeFn = () => subscription.unsubscribe(unsubscribeMessage);
    return unsubscribeFn;
  };
}

export default AISummaryResolver;
